'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from 'react';
const usePersonalPermissions = tree => {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [clearableStack, setClearableStack] = useState(t0);
  let t1;
  if ($[1] !== tree) {
    t1 = tree.find(_temp);
    $[1] = tree;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const node = t1;
  let t2;
  if ($[3] !== node) {
    t2 = node ? node.children : [];
    $[3] = node;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const sources = t2;
  let t3;
  if ($[5] !== tree) {
    t3 = tree.find(_temp2);
    $[5] = tree;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const node_0 = t3;
  let t4;
  if ($[7] !== node_0) {
    t4 = node_0 ? node_0.children : [];
    $[7] = node_0;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const seeks = t4;
  let t5;
  if ($[9] !== seeks || $[10] !== sources) {
    t5 = (source, seek) => {
      if (!seek && !source) {
        return sources;
      }
      if (source) {
        return sources.filter(t6 => {
          const {
            handle: handle_1
          } = t6;
          return handle_1 === source;
        });
      }
      if (seek === "ANYONE") {
        return seeks;
      }
      const node_1 = seeks.find(t7 => {
        const {
          handle: handle_2
        } = t7;
        return handle_2 === seek;
      });
      if (node_1) {
        return node_1.children.filter(_temp3);
      }
      return [];
    };
    $[9] = seeks;
    $[10] = sources;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const permissionSources = t5;
  let t6;
  if ($[12] !== seeks || $[13] !== sources) {
    t6 = (source_0, seek_0) => {
      if (!source_0 && !seek_0) {
        return seeks;
      }
      if (seek_0) {
        return seeks.filter(t7 => {
          const {
            handle: handle_3
          } = t7;
          return handle_3 === seek_0;
        });
      }
      if (source_0 === "ANYONE") {
        return sources;
      }
      const node_2 = sources.find(t8 => {
        const {
          handle: handle_4
        } = t8;
        return handle_4 === source_0;
      });
      if (node_2) {
        return node_2.children.filter(_temp4);
      }
      return [];
    };
    $[12] = seeks;
    $[13] = sources;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const permissionSeeks = t6;
  let t7;
  if ($[15] !== clearableStack) {
    t7 = handle_5 => clearableStack.length === 0 ? true : clearableStack[clearableStack.length - 1] === handle_5;
    $[15] = clearableStack;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const isPermissionClearable = t7;
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = orientation => setClearableStack(prev => {
      if (prev.length === 0) {
        return prev.concat(orientation);
      }
      if (prev.length < 2 && prev[prev.length - 1] !== orientation) {
        return prev.concat(orientation);
      }
      return prev;
    });
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const pushClearablePermission = t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = orientation_0 => setClearableStack(prev_0 => prev_0.filter(handle_6 => handle_6 !== orientation_0));
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const popClearablePermission = t9;
  let t10;
  if ($[19] !== isPermissionClearable || $[20] !== permissionSeeks || $[21] !== permissionSources) {
    t10 = {
      permissionSources,
      permissionSeeks,
      pushClearablePermission,
      popClearablePermission,
      isPermissionClearable
    };
    $[19] = isPermissionClearable;
    $[20] = permissionSeeks;
    $[21] = permissionSources;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default usePersonalPermissions;
function _temp(t0) {
  const {
    handle
  } = t0;
  return handle === "SOURCE";
}
function _temp2(t0) {
  const {
    handle: handle_0
  } = t0;
  return handle_0 === "SEEK";
}
function _temp3(t0) {
  const {
    status
  } = t0;
  return status === 1;
}
function _temp4(t0) {
  const {
    status: status_0
  } = t0;
  return status_0 === 1;
}